import { Image } from "@aws-amplify/ui-react";
import { Box, CircularProgress, Typography } from "@mui/material";
import logo from "./logo-Tuclase-blanco.svg";
import bottomPattern from "./Union-bottom.svg"; // Importa el SVG inferior
import topPattern from "./Union.svg"; // Importa el SVG superior

export function LoadingScreen() {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        backgroundImage: "linear-gradient(to bottom, #90AFC5, #336B87)",
        backgroundSize: "cover",
      }}
    >
      {/* Figura geométrica superior */}
      <img
        src={topPattern}
        alt="Top Pattern"
        style={{
          position: "absolute",
          top: "-50px",
          left: 0,
          width: "100%",
          height: "auto",
        }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 1.5,
          textAlign: "center",
          zIndex: 5, // Asegúrate de que el contenido esté sobre las figuras geométricas
        }}
      >
        <Image
          style={{ width: 380, height: "auto" }}
          alt="Amplify logo"
          src={logo}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 3,
          }}
        >
          <CircularProgress size={30} sx={{ color: "white" }} />
        </Box>

        <Typography
          sx={{
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "0.8rem",
            fontWeight: "normal",
            mt: 3,
          }}
          variant="h3"
        >
          Cargando información del usuario...
        </Typography>
      </Box>

      {/* Figura geométrica inferior */}
      <img
        src={bottomPattern}
        alt="Bottom Pattern"
        style={{
          position: "absolute",
          bottom: "-50px",
          left: 0,
          width: "100%",
          height: "auto",
        }}
      />
    </Box>
  );
}
